<template>
  <wh-mobile-list ref="pickList" class="pick-list" :extra-params="extraParams" data-src="/api/getControlPickList">
    <template v-slot="{list}">
      <div class="pick-list">
        <div v-for="(item,key) in list" :key="key" class="pick-list-item">
          <div class="top-content wh-flex-between">
            <div>
              <div class="name">
                {{ item.cropBreed }}
              </div>
              <div class="time">
                {{ formatTime(item.pickTime) }}
              </div>
            </div>
            <div class="pick-count">
              <span class="pick-num">{{ item.pickNum }}</span><span class="unit">{{ item.unit }}</span>
            </div>
          </div>
          <div class="options">
            <router-link v-if="item.traceStatus" class="option-item create" tag="div" :to="{name:'TraceSource', query: { landId: landId, traceCode: item.traceCode }}">
              <van-icon name="qr" /> 查看溯源
            </router-link>
            <router-link v-else class="option-item edit" tag="div" :to="{name:'TraceSourceEditor', query: { landId: landId, formType: 'create', traceCode: item.traceCode }}">
              <van-icon name="edit" /> 创建溯源
            </router-link>
          </div>
        </div>
      </div>
    </template>
  </wh-mobile-list>
</template>
<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { formatTime } from '@/utils/convert/convertTime'

export default {
  name: 'PickRecord',
  components: { WhMobileList },
  props: {
    // 通过绑定 route.query 传递
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      extraParams: {
        fuzzy: 1,
        landId: this.landId,
        breedType: undefined,
        startDate: undefined,
        endDate: undefined
      }
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>
.pick-list-item {
  margin: 20px;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 #ccc;
  .top-content {
    .name {
      font-size: 16px;

    }
    .time {
      font-size: 14px;
      color: #ccc;
      margin-top: 6px;
    }
    .pick-count {
      .pick-num {
        font-size: 20px;
        font-weight: bold;
      }
      .unit {
        margin-left: 4px;
      }
    }
  }
  .options {
    margin-top: 10px;
  }
}
.options {
  .option-item {
    text-align: center;
    width: 100%;
    border-radius: 4px;
    padding: 5px;
    line-height: 1;
    color: #fff;
    &.create {
      background: @primary-color;
    }
    &.edit {
      background: fade(@primary-color, 50%);
    }
  }
}
</style>
